import { render, staticRenderFns } from "./CourseOpenTip.vue?vue&type=template&id=62e86fcc&scoped=true"
import script from "./CourseOpenTip.vue?vue&type=script&lang=js"
export * from "./CourseOpenTip.vue?vue&type=script&lang=js"
import style0 from "./CourseOpenTip.vue?vue&type=style&index=0&id=62e86fcc&prod&lang=scss&scoped=true"
import style1 from "./CourseOpenTip.vue?vue&type=style&index=1&id=62e86fcc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e86fcc",
  null
  
)

export default component.exports